import React from "react";
import { Col, Row, Container } from "reactstrap";

const Banner = () => (
  <Row className="banner home--banner">
    <Col sm="10" lg="7">
      <h1>
        Software crafted by the <span>under</span>served
      </h1>
      <h2>Tech Projects with a Social Impact</h2>
      {/* <p style={{ textAlign: "left" }} />
      <br /> */}
      {/* <p>
          <a className="btn btn-lg home-button" size="lg" href="/solutions">
            Learn More
          </a>{" "}
          <Button className="home-button" size="lg">
            Contact
          </Button>{" "}
        </p> */}
    </Col>
  </Row>
);

export default Banner;

// > We use Agile and Lean Startup principles to help you make digital
//           products for social good We bring together companies and refugees in a
//           collective effort to expand opportunity and build a brighter future
//           for all.
//           We work in agile with sprints, but that's not all. We believe in
//         craftsmanship and creating quality products made with a process that is
//         perfected to ensure success.



// WEBPACK FOOTER //
// ./src/pages/Home/Banner.js